module.exports = __webpack_public_path__ + "img/product.a0f3ffa0.png";